// Spender segments
export const segments = [
  {
    id: 'whales',
    name: 'Whales',
    description: 'High spending users (>$100/mo)',
  },
  {
    id: 'dolphins',
    name: 'Dolphins',
    description: 'Medium spending users ($20-$100/mo)',
  },
  {
    id: 'minnows',
    name: 'Minnows',
    description: 'Low spending users ($1-$20/mo)',
  },
  {
    id: 'non_spenders',
    name: 'Non-Spenders',
    description: "Users who haven't spent yet",
  },
  {
    id: 'churn_risk',
    name: 'Churn Risk',
    description: 'Users at risk of churning',
  },
]
// Algorithm types
export const algorithmTypes = [
  {
    id: 'lookalike',
    name: 'Lookalike',
    description: 'Based on similar user profiles',
  },
  {
    id: 'broad',
    name: 'Broad',
    description: 'Broad targeting with minimal filters',
  },
  {
    id: 'context',
    name: 'Context',
    description: 'Based on current user context/activity',
  },
  {
    id: 'persona',
    name: 'Persona',
    description: 'Based on user persona/interests',
  },
]
// GEOs
export const geos = [
  { id: 'us', name: 'United States', code: 'US', tier: 'Tier 1' },
  { id: 'ca', name: 'Canada', code: 'CA', tier: 'Tier 1' },
  { id: 'uk', name: 'United Kingdom', code: 'UK', tier: 'Tier 1' },
  { id: 'au', name: 'Australia', code: 'AU', tier: 'Tier 1' },
  { id: 'de', name: 'Germany', code: 'DE', tier: 'Tier 1' },
  { id: 'fr', name: 'France', code: 'FR', tier: 'Tier 1' },
  { id: 'it', name: 'Italy', code: 'IT', tier: 'Tier 1' },
  { id: 'jp', name: 'Japan', code: 'JP', tier: 'Tier 1' },
  { id: 'br', name: 'Brazil', code: 'BR', tier: 'Tier 2' },
  { id: 'mx', name: 'Mexico', code: 'MX', tier: 'Tier 2' },
  { id: 'in', name: 'India', code: 'IN', tier: 'Tier 2' },
  { id: 'ru', name: 'Russia', code: 'RU', tier: 'Tier 2' },
  { id: 'za', name: 'South Africa', code: 'ZA', tier: 'Tier 2' },
]
// Verticals
export const verticals = [
  { id: 'cams', name: 'Cams', description: 'Live webcam services' },
  { id: 'nutra', name: 'Nutra', description: 'Nutraceuticals and supplements' },
  { id: 'dating', name: 'Dating', description: 'Dating services' },
  {
    id: 'games',
    name: 'Games',
    description: 'Online games and gaming services',
  },
  { id: 'vpn', name: 'VPN', description: 'Virtual Private Network services' },
  { id: 'crypto', name: 'Crypto', description: 'Cryptocurrency services' },
  { id: 'cbd', name: 'CBD', description: 'CBD products' },
  { id: 'adult', name: 'Adult', description: 'Adult content and services' },
  { id: 'gambling', name: 'Gambling', description: 'Online gambling services' },
]
// Devices
export const devices = [
  { id: 'desktop', name: 'Desktop' },
  { id: 'mobile', name: 'Mobile' },
  { id: 'tablet', name: 'Tablet' },
]
// Operating Systems
export const operatingSystems = [
  { id: 'windows', name: 'Windows' },
  { id: 'macos', name: 'macOS' },
  { id: 'linux', name: 'Linux' },
  { id: 'ios', name: 'iOS' },
  { id: 'android', name: 'Android' },
]
// Browsers
export const browsers = [
  { id: 'chrome', name: 'Chrome' },
  { id: 'firefox', name: 'Firefox' },
  { id: 'safari', name: 'Safari' },
  { id: 'edge', name: 'Edge' },
  { id: 'opera', name: 'Opera' },
]
// Languages
export const languages = [
  { id: 'en', name: 'English' },
  { id: 'es', name: 'Spanish' },
  { id: 'fr', name: 'French' },
  { id: 'de', name: 'German' },
  { id: 'it', name: 'Italian' },
  { id: 'pt', name: 'Portuguese' },
  { id: 'ru', name: 'Russian' },
  { id: 'ja', name: 'Japanese' },
  { id: 'zh', name: 'Chinese' },
]
// Channels
export const channels = [
  { id: 'exoclick', name: 'ExoClick' },
  { id: 'mirelia', name: 'Mirelia' },
  { id: 'trafficjunky', name: 'TrafficJunky' },
  { id: 'trafficfactory', name: 'TrafficFactory' },
  { id: 'juicyads', name: 'JuicyAds' },
  { id: 'plugrush', name: 'PlugRush' },
  { id: 'adsterra', name: 'Adsterra' },
  { id: 'propellerads', name: 'PropellerAds' },
]
// Entry Funnels
export const entryFunnels = [
  { id: 'quiz', name: 'Quiz' },
  { id: 'chatbot', name: 'Chatbot' },
  { id: 'single_step', name: 'Single Step' },
  { id: 'email', name: 'Email' },
  { id: 'push', name: 'Push Notification' },
  { id: 'social', name: 'Social Media' },
]
// Payout Models
export const payoutModels = [
  { id: 'cpa', name: 'CPA', description: 'Cost Per Acquisition' },
  { id: 'cps', name: 'CPS', description: 'Cost Per Sale' },
  { id: 'revshare', name: 'RevShare', description: 'Revenue Share' },
]
// Currencies
export const currencies = [
  { id: 'usd', name: 'USD', symbol: '$' },
  { id: 'eur', name: 'EUR', symbol: '€' },
  { id: 'gbp', name: 'GBP', symbol: '£' },
]
// Pacing Options
export const pacingOptions = [
  {
    id: 'even',
    name: 'Even',
    description: 'Distribute traffic evenly throughout the day',
  },
  {
    id: 'asap',
    name: 'ASAP',
    description: 'Send traffic as quickly as possible until cap is reached',
  },
]
// Pixel Types
export const pixelTypes = [
  { id: 'image', name: 'Image Pixel' },
  { id: 'iframe', name: 'iFrame Pixel' },
  { id: 'js', name: 'JavaScript Pixel' },
  { id: 's2s', name: 'Server-to-Server' },
]
// Aspect Ratios
export const aspectRatios = [
  { id: '16_9', name: '16:9', width: 16, height: 9 },
  { id: '4_3', name: '4:3', width: 4, height: 3 },
  { id: '1_1', name: '1:1', width: 1, height: 1 },
  { id: '9_16', name: '9:16', width: 9, height: 16 },
  { id: '2_1', name: '2:1', width: 2, height: 1 },
]
// Trigger Types
export const triggerTypes = [
  { id: 'purchase_success', name: 'Purchase Success' },
  { id: 'purchase_decline', name: 'Purchase Decline' },
  { id: 'exit_intent', name: 'Exit Intent' },
  { id: 'ritual_complete', name: 'Ritual Complete' },
  { id: 'content_unlock', name: 'Content Unlock' },
  { id: 'session_timeout', name: 'Session Timeout' },
]
// UX Types
export const uxTypes = [
  { id: 'full_screen_modal', name: 'Full Screen Modal' },
  { id: 'bottom_sheet', name: 'Bottom Sheet' },
  { id: 'toast_with_cta', name: 'Toast with CTA' },
  { id: 'interstitial', name: 'Interstitial' },
]
// Frequency Cap Types
export const frequencyCaps = [
  { id: 'per_session', name: 'Per Session' },
  { id: 'per_day', name: 'Per Day' },
  { id: 'per_week', name: 'Per Week' },
]
// Optimization Modes
export const optimizationModes = [
  { id: 'rpm', name: 'RPM Optimized' },
  { id: 'epc', name: 'EPC Optimized' },
  { id: 'cvr', name: 'CVR Optimized' },
  { id: 'manual', name: 'Manual (Priority/Weight)' },
]
// Sample Backoffers
export const backoffers = [
  {
    id: 'bo_1',
    status: 'active',
    name: 'Premium Cams Offer',
    partnerId: 'partner_1',
    partnerName: 'StreamMate',
    verticalId: 'cams',
    description: 'High converting webcam offer with $42 average CPA',
    baseUrl: 'https://example.com/cams',
    trackingParams: {
      utm_source: 'sinshift',
      utm_campaign: 'fallback',
      subid: '{subid}',
      click_id: '{click_id}',
    },
    payoutModelId: 'cpa',
    currencyId: 'usd',
    payoutAmount: 42,
    holdDays: 7,
    payoutNotes: 'Weekly payment, NET7',
    targeting: {
      geos: ['us', 'ca', 'uk', 'au'],
      excludedGeos: [],
      devices: ['desktop', 'mobile'],
      operatingSystems: ['windows', 'macos', 'ios', 'android'],
      browsers: ['chrome', 'firefox', 'safari'],
      languages: ['en'],
      timeOfDay: { start: 0, end: 24 },
      daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
    },
    segmentTargeting: {
      segments: ['non_spenders', 'minnows'],
      fallbackType: 'persona',
    },
    caps: {
      daily: 1000,
      hourly: 100,
      frequency: 3,
      pacingId: 'even',
    },
    priority: 10,
    weight: 100,
    compliance: {
      adultFlag: true,
      restrictedGeos: ['in', 'ru'],
      ageGate: true,
      kycNeeded: false,
      partnerTermsUrl: 'https://example.com/terms',
      internalRiskScore: 2,
    },
    tracking: {
      clickMacroTokens: '{click_id}',
      postbackUrl:
        'https://sinshift.com/postback?click_id={click_id}&status={status}',
      webhookEnabled: true,
      pixelTypeId: 's2s',
    },
    creatives: [
      {
        id: 'creative_1',
        type: 'banner',
        aspectRatioId: '16_9',
        url: 'https://picsum.photos/800/450',
        headline: 'Live Cams Now',
        cta: 'Join Free',
        approved: true,
      },
    ],
    performance: {
      impressions: 50000,
      clicks: 2500,
      conversions: 250,
      revenue: 10500,
      epc: 4.2,
      cr: 0.1,
      rpm: 210,
      refundRate: 0.02,
      segmentPerformance: {
        whales: { cr: 0.15, epc: 6.3, rpm: 315 },
        dolphins: { cr: 0.12, epc: 5.04, rpm: 252 },
        minnows: { cr: 0.1, epc: 4.2, rpm: 210 },
        non_spenders: { cr: 0.08, epc: 3.36, rpm: 168 },
        churn_risk: { cr: 0.05, epc: 2.1, rpm: 105 },
      },
      geoPerformance: {
        us: { cr: 0.12, epc: 5.04, rpm: 252 },
        ca: { cr: 0.1, epc: 4.2, rpm: 210 },
        uk: { cr: 0.09, epc: 3.78, rpm: 189 },
        au: { cr: 0.08, epc: 3.36, rpm: 168 },
      },
      devicePerformance: {
        desktop: { cr: 0.11, epc: 4.62, rpm: 231 },
        mobile: { cr: 0.09, epc: 3.78, rpm: 189 },
      },
      channelPerformance: {
        exoclick: { cr: 0.1, epc: 4.2, rpm: 210 },
        mirelia: { cr: 0.09, epc: 3.78, rpm: 189 },
      },
      funnelPerformance: {
        quiz: { cr: 0.12, epc: 5.04, rpm: 252 },
        chatbot: { cr: 0.1, epc: 4.2, rpm: 210 },
        single_step: { cr: 0.08, epc: 3.36, rpm: 168 },
      },
      trendData: {
        dates: [
          '2023-07-01',
          '2023-07-02',
          '2023-07-03',
          '2023-07-04',
          '2023-07-05',
          '2023-07-06',
          '2023-07-07',
        ],
        revenue: [1400, 1500, 1450, 1600, 1550, 1500, 1500],
        epc: [4.1, 4.2, 4.1, 4.3, 4.2, 4.2, 4.2],
        cr: [0.09, 0.1, 0.095, 0.105, 0.1, 0.1, 0.1],
      },
      anomalyAlerts: [
        {
          id: 'alert_1',
          type: 'epc_drop',
          message: 'EPC dropped 15% in the last 24 hours for US traffic',
          severity: 'medium',
          timestamp: '2023-07-07T10:30:00Z',
        },
      ],
    },
  },
  {
    id: 'bo_2',
    status: 'active',
    name: 'Premium Dating Offer',
    partnerId: 'partner_2',
    partnerName: 'DateNow',
    verticalId: 'dating',
    description: 'High quality dating offer with $38 CPA',
    baseUrl: 'https://example.com/dating',
    trackingParams: {
      utm_source: 'sinshift',
      utm_campaign: 'fallback',
      subid: '{subid}',
      click_id: '{click_id}',
    },
    payoutModelId: 'cpa',
    currencyId: 'usd',
    payoutAmount: 38,
    holdDays: 15,
    payoutNotes: 'Bi-weekly payment, NET15',
    targeting: {
      geos: ['us', 'ca', 'uk', 'au', 'de', 'fr'],
      excludedGeos: [],
      devices: ['desktop', 'mobile', 'tablet'],
      operatingSystems: ['windows', 'macos', 'ios', 'android'],
      browsers: ['chrome', 'firefox', 'safari', 'edge'],
      languages: ['en', 'de', 'fr'],
      timeOfDay: { start: 0, end: 24 },
      daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
    },
    segmentTargeting: {
      segments: ['non_spenders', 'minnows', 'dolphins'],
      fallbackType: 'lookalike',
    },
    caps: {
      daily: 1500,
      hourly: 150,
      frequency: 2,
      pacingId: 'even',
    },
    priority: 8,
    weight: 80,
    compliance: {
      adultFlag: false,
      restrictedGeos: ['in', 'ru'],
      ageGate: true,
      kycNeeded: false,
      partnerTermsUrl: 'https://example.com/terms',
      internalRiskScore: 1,
    },
    tracking: {
      clickMacroTokens: '{click_id}',
      postbackUrl:
        'https://sinshift.com/postback?click_id={click_id}&status={status}',
      webhookEnabled: true,
      pixelTypeId: 's2s',
    },
    creatives: [
      {
        id: 'creative_2',
        type: 'banner',
        aspectRatioId: '16_9',
        url: 'https://picsum.photos/800/450',
        headline: 'Find Your Match Today',
        cta: 'Join Now',
        approved: true,
      },
    ],
    performance: {
      impressions: 75000,
      clicks: 3750,
      conversions: 300,
      revenue: 11400,
      epc: 3.04,
      cr: 0.08,
      rpm: 152,
      refundRate: 0.03,
      segmentPerformance: {
        whales: { cr: 0.12, epc: 4.56, rpm: 228 },
        dolphins: { cr: 0.1, epc: 3.8, rpm: 190 },
        minnows: { cr: 0.08, epc: 3.04, rpm: 152 },
        non_spenders: { cr: 0.06, epc: 2.28, rpm: 114 },
        churn_risk: { cr: 0.04, epc: 1.52, rpm: 76 },
      },
      geoPerformance: {
        us: { cr: 0.09, epc: 3.42, rpm: 171 },
        ca: { cr: 0.08, epc: 3.04, rpm: 152 },
        uk: { cr: 0.08, epc: 3.04, rpm: 152 },
        au: { cr: 0.07, epc: 2.66, rpm: 133 },
        de: { cr: 0.07, epc: 2.66, rpm: 133 },
        fr: { cr: 0.07, epc: 2.66, rpm: 133 },
      },
      devicePerformance: {
        desktop: { cr: 0.09, epc: 3.42, rpm: 171 },
        mobile: { cr: 0.08, epc: 3.04, rpm: 152 },
        tablet: { cr: 0.07, epc: 2.66, rpm: 133 },
      },
      channelPerformance: {
        exoclick: { cr: 0.08, epc: 3.04, rpm: 152 },
        mirelia: { cr: 0.07, epc: 2.66, rpm: 133 },
        trafficjunky: { cr: 0.09, epc: 3.42, rpm: 171 },
      },
      funnelPerformance: {
        quiz: { cr: 0.09, epc: 3.42, rpm: 171 },
        chatbot: { cr: 0.08, epc: 3.04, rpm: 152 },
        single_step: { cr: 0.07, epc: 2.66, rpm: 133 },
      },
      trendData: {
        dates: [
          '2023-07-01',
          '2023-07-02',
          '2023-07-03',
          '2023-07-04',
          '2023-07-05',
          '2023-07-06',
          '2023-07-07',
        ],
        revenue: [1600, 1650, 1600, 1700, 1650, 1600, 1600],
        epc: [3.0, 3.1, 3.0, 3.2, 3.1, 3.0, 3.0],
        cr: [0.07, 0.08, 0.075, 0.085, 0.08, 0.08, 0.08],
      },
      anomalyAlerts: [],
    },
  },
]
// Sample Second-Click Offers
export const secondClickOffers = [
  {
    id: 'sc_1',
    status: 'active',
    name: 'Token Package Upsell',
    triggerId: 'purchase_success',
    placementId: 'full_screen_modal',
    description: 'Upsell token package after successful purchase',
    offerSource: {
      type: 'internal',
      productId: 'token_package_1',
      productName: '500 Tokens',
      regularPrice: 49.99,
      discountedPrice: 39.99,
      discountPercentage: 20,
    },
    targeting: {
      geos: ['us', 'ca', 'uk', 'au', 'de', 'fr'],
      excludedGeos: [],
      devices: ['desktop', 'mobile', 'tablet'],
      segments: ['minnows', 'dolphins'],
      fallbackType: 'persona',
    },
    pricingAndDiscounts: {
      dynamicIncentives: true,
      oneTimeBonus: '100 Extra Tokens',
      countdown: {
        enabled: true,
        minutes: 15,
      },
    },
    frequencyCaps: {
      typeId: 'per_day',
      value: 2,
      dontShowAfterViews: 5,
    },
    creative: {
      title: 'Limited Time Offer!',
      imageUrl: 'https://picsum.photos/600/400',
      copyVariants: [
        'Get 500 tokens for the price of 400! Limited time offer.',
        'Exclusive offer just for you: 20% off tokens!',
      ],
      autoAB: true,
      weights: [50, 50],
    },
    tracking: {
      clickId: '{click_id}',
      subid: '{subid}',
      postbackUrl:
        'https://sinshift.com/postback?click_id={click_id}&status={status}',
    },
    performance: {
      triggered: 5000,
      viewed: 4500,
      clicked: 900,
      converted: 270,
      revenue: 10797,
      rpm: 2399.33,
      attachRate: 0.06,
      cr: 0.06,
      segmentPerformance: {
        whales: { cr: 0.08, rpm: 3199.11, attachRate: 0.08 },
        dolphins: { cr: 0.06, rpm: 2399.33, attachRate: 0.06 },
        minnows: { cr: 0.04, rpm: 1599.56, attachRate: 0.04 },
        non_spenders: { cr: 0.02, rpm: 799.78, attachRate: 0.02 },
        churn_risk: { cr: 0.01, rpm: 399.89, attachRate: 0.01 },
      },
      liftVsControl: {
        revenue: 3500,
        percentage: 48,
        isWinner: true,
      },
    },
  },
  {
    id: 'sc_2',
    status: 'active',
    name: 'VIP Membership Upsell',
    triggerId: 'ritual_complete',
    placementId: 'bottom_sheet',
    description: 'Upsell VIP membership after ritual completion',
    offerSource: {
      type: 'internal',
      productId: 'vip_membership',
      productName: 'VIP Membership',
      regularPrice: 29.99,
      discountedPrice: 19.99,
      discountPercentage: 33,
    },
    targeting: {
      geos: ['us', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'jp'],
      excludedGeos: [],
      devices: ['desktop', 'mobile'],
      segments: ['minnows', 'dolphins', 'whales'],
      fallbackType: 'lookalike',
    },
    pricingAndDiscounts: {
      dynamicIncentives: true,
      oneTimeBonus: 'Free Angel Skin',
      countdown: {
        enabled: true,
        minutes: 30,
      },
    },
    frequencyCaps: {
      typeId: 'per_session',
      value: 1,
      dontShowAfterViews: 3,
    },
    creative: {
      title: 'Upgrade to VIP!',
      imageUrl: 'https://picsum.photos/600/400',
      copyVariants: [
        'Get exclusive access to premium content with VIP!',
        'Unlock all features with our VIP membership - 33% off today!',
      ],
      autoAB: true,
      weights: [50, 50],
    },
    tracking: {
      clickId: '{click_id}',
      subid: '{subid}',
      postbackUrl:
        'https://sinshift.com/postback?click_id={click_id}&status={status}',
    },
    performance: {
      triggered: 10000,
      viewed: 9500,
      clicked: 1900,
      converted: 380,
      revenue: 7596.2,
      rpm: 799.6,
      attachRate: 0.038,
      cr: 0.04,
      segmentPerformance: {
        whales: { cr: 0.06, rpm: 1199.4, attachRate: 0.06 },
        dolphins: { cr: 0.04, rpm: 799.6, attachRate: 0.04 },
        minnows: { cr: 0.03, rpm: 599.7, attachRate: 0.03 },
        non_spenders: { cr: 0.01, rpm: 199.9, attachRate: 0.01 },
        churn_risk: { cr: 0.005, rpm: 99.95, attachRate: 0.005 },
      },
      liftVsControl: {
        revenue: 2500,
        percentage: 49,
        isWinner: true,
      },
    },
  },
  {
    id: 'sc_3',
    status: 'active',
    name: 'Dating Offer After Chat Exit',
    triggerId: 'exit_intent',
    placementId: 'interstitial',
    description: 'External dating offer shown after chat exit intent',
    offerSource: {
      type: 'external',
      partnerId: 'partner_2',
      partnerName: 'DateNow',
      baseUrl: 'https://example.com/dating',
      trackingParams: {
        utm_source: 'sinshift',
        utm_campaign: 'second_click',
        subid: '{subid}',
        click_id: '{click_id}',
      },
      payoutModelId: 'cpa',
      payoutAmount: 38,
    },
    targeting: {
      geos: ['us', 'ca', 'uk', 'au', 'de', 'fr'],
      excludedGeos: [],
      devices: ['desktop', 'mobile', 'tablet'],
      segments: ['non_spenders', 'minnows', 'churn_risk'],
      fallbackType: 'context',
    },
    pricingAndDiscounts: {
      dynamicIncentives: false,
      oneTimeBonus: '',
      countdown: {
        enabled: false,
        minutes: 0,
      },
    },
    frequencyCaps: {
      typeId: 'per_day',
      value: 1,
      dontShowAfterViews: 2,
    },
    creative: {
      title: 'Find Real Dates',
      imageUrl: 'https://picsum.photos/600/400',
      copyVariants: [
        'Meet singles in your area today!',
        'Find your perfect match now!',
      ],
      autoAB: true,
      weights: [50, 50],
    },
    tracking: {
      clickId: '{click_id}',
      subid: '{subid}',
      postbackUrl:
        'https://sinshift.com/postback?click_id={click_id}&status={status}',
    },
    performance: {
      triggered: 15000,
      viewed: 12000,
      clicked: 1800,
      converted: 144,
      revenue: 5472,
      rpm: 456,
      attachRate: 0.0096,
      cr: 0.012,
      segmentPerformance: {
        whales: { cr: 0.015, rpm: 570, attachRate: 0.012 },
        dolphins: { cr: 0.012, rpm: 456, attachRate: 0.0096 },
        minnows: { cr: 0.01, rpm: 380, attachRate: 0.008 },
        non_spenders: { cr: 0.008, rpm: 304, attachRate: 0.0064 },
        churn_risk: { cr: 0.006, rpm: 228, attachRate: 0.0048 },
      },
      liftVsControl: {
        revenue: 1800,
        percentage: 49,
        isWinner: true,
      },
    },
  },
]
// Sample Smartlinks
export const smartlinks = [
  {
    id: 'sl_1',
    status: 'active',
    name: 'Premium Dating Smartlink',
    description: 'Dating smartlink with auto-optimization for highest RPM',
    offersInPool: [
      {
        offerId: 'bo_2',
        offerName: 'Premium Dating Offer',
        weight: 60,
        priority: 1,
      },
      {
        offerId: 'sc_3',
        offerName: 'Dating Offer After Chat Exit',
        weight: 40,
        priority: 2,
      },
    ],
    strategyId: 'rpm',
    segments: ['non_spenders', 'minnows', 'dolphins'],
    geos: ['us', 'ca', 'uk', 'au', 'de', 'fr'],
    baseUrl: 'https://sinshift.com/sl/dating',
    urlParams: {
      click_id: '{click_id}',
      subid: '{subid}',
      geo: '{geo}',
      device: '{device}',
    },
    failover: {
      enabled: true,
      nextEligibleByPriority: true,
      protection404: true,
    },
    caps: {
      daily: 5000,
      hourly: 500,
      spilloverRules: 'next_priority',
    },
    performance: {
      clicks: 10000,
      conversions: 800,
      revenue: 30400,
      epc: 3.04,
      cr: 0.08,
      rpm: 3040,
      offerContribution: [
        {
          offerId: 'bo_2',
          offerName: 'Premium Dating Offer',
          clicks: 6000,
          conversions: 480,
          revenue: 18240,
          epc: 3.04,
          cr: 0.08,
          rpm: 3040,
          percentage: 60,
        },
        {
          offerId: 'sc_3',
          offerName: 'Dating Offer After Chat Exit',
          clicks: 4000,
          conversions: 320,
          revenue: 12160,
          epc: 3.04,
          cr: 0.08,
          rpm: 3040,
          percentage: 40,
        },
      ],
      segmentPerformance: {
        whales: { cr: 0.12, epc: 4.56, rpm: 4560 },
        dolphins: { cr: 0.1, epc: 3.8, rpm: 3800 },
        minnows: { cr: 0.08, epc: 3.04, rpm: 3040 },
        non_spenders: { cr: 0.06, epc: 2.28, rpm: 2280 },
        churn_risk: { cr: 0.04, epc: 1.52, rpm: 1520 },
      },
      geoPerformance: {
        us: { cr: 0.09, epc: 3.42, rpm: 3420 },
        ca: { cr: 0.08, epc: 3.04, rpm: 3040 },
        uk: { cr: 0.08, epc: 3.04, rpm: 3040 },
        au: { cr: 0.07, epc: 2.66, rpm: 2660 },
        de: { cr: 0.07, epc: 2.66, rpm: 2660 },
        fr: { cr: 0.07, epc: 2.66, rpm: 2660 },
      },
      rpmTrend: {
        dates: [
          '2023-07-01',
          '2023-07-02',
          '2023-07-03',
          '2023-07-04',
          '2023-07-05',
          '2023-07-06',
          '2023-07-07',
        ],
        rpm: [3000, 3050, 3020, 3100, 3080, 3060, 3040],
      },
    },
  },
  {
    id: 'sl_2',
    status: 'active',
    name: 'Webcam Smartlink',
    description: 'Webcam smartlink with auto-optimization for highest EPC',
    offersInPool: [
      {
        offerId: 'bo_1',
        offerName: 'Premium Cams Offer',
        weight: 70,
        priority: 1,
      },
      {
        offerId: 'sc_1',
        offerName: 'Token Package Upsell',
        weight: 30,
        priority: 2,
      },
    ],
    strategyId: 'epc',
    segments: ['non_spenders', 'minnows', 'dolphins', 'whales'],
    geos: ['us', 'ca', 'uk', 'au'],
    baseUrl: 'https://sinshift.com/sl/cams',
    urlParams: {
      click_id: '{click_id}',
      subid: '{subid}',
      geo: '{geo}',
      device: '{device}',
    },
    failover: {
      enabled: true,
      nextEligibleByPriority: true,
      protection404: true,
    },
    caps: {
      daily: 3000,
      hourly: 300,
      spilloverRules: 'next_priority',
    },
    performance: {
      clicks: 8000,
      conversions: 800,
      revenue: 33600,
      epc: 4.2,
      cr: 0.1,
      rpm: 4200,
      offerContribution: [
        {
          offerId: 'bo_1',
          offerName: 'Premium Cams Offer',
          clicks: 5600,
          conversions: 560,
          revenue: 23520,
          epc: 4.2,
          cr: 0.1,
          rpm: 4200,
          percentage: 70,
        },
        {
          offerId: 'sc_1',
          offerName: 'Token Package Upsell',
          clicks: 2400,
          conversions: 240,
          revenue: 10080,
          epc: 4.2,
          cr: 0.1,
          rpm: 4200,
          percentage: 30,
        },
      ],
      segmentPerformance: {
        whales: { cr: 0.15, epc: 6.3, rpm: 6300 },
        dolphins: { cr: 0.12, epc: 5.04, rpm: 5040 },
        minnows: { cr: 0.1, epc: 4.2, rpm: 4200 },
        non_spenders: { cr: 0.08, epc: 3.36, rpm: 3360 },
        churn_risk: { cr: 0.05, epc: 2.1, rpm: 2100 },
      },
      geoPerformance: {
        us: { cr: 0.12, epc: 5.04, rpm: 5040 },
        ca: { cr: 0.1, epc: 4.2, rpm: 4200 },
        uk: { cr: 0.09, epc: 3.78, rpm: 3780 },
        au: { cr: 0.08, epc: 3.36, rpm: 3360 },
      },
      rpmTrend: {
        dates: [
          '2023-07-01',
          '2023-07-02',
          '2023-07-03',
          '2023-07-04',
          '2023-07-05',
          '2023-07-06',
          '2023-07-07',
        ],
        rpm: [4150, 4180, 4200, 4220, 4210, 4200, 4200],
      },
    },
  },
]
// Smart Banners
export const smartBanners = [
  {
    id: 'sb_1',
    status: 'active',
    name: 'Premium Cams Banner',
    title: 'Live Cams Now',
    description: 'Chat with hot models live - join free!',
    ctaText: 'Join Free',
    image: 'https://picsum.photos/800/450',
    destination: {
      type: 'backoffer',
      offerId: 'bo_1',
    },
    targeting: {
      primary: 'algorithmic',
      fallback: {
        segment: 'non_spenders',
        persona: 'excitement_seeker',
      },
    },
    performance: {
      impressions: 50000,
      clicks: 2500,
      conversions: 250,
      revenue: 10500,
      ctr: 0.05,
      cr: 0.1,
      rpm: 210,
      attachRate: 0.005,
      segmentPerformance: {
        whales: { ctr: 0.07, cr: 0.15, rpm: 315, attachRate: 0.0105 },
        dolphins: { ctr: 0.06, cr: 0.12, rpm: 252, attachRate: 0.0072 },
        minnows: { ctr: 0.05, cr: 0.1, rpm: 210, attachRate: 0.005 },
        non_spenders: { ctr: 0.04, cr: 0.08, rpm: 168, attachRate: 0.0032 },
        churn_risk: { ctr: 0.03, cr: 0.05, rpm: 105, attachRate: 0.0015 },
      },
    },
  },
  {
    id: 'sb_2',
    status: 'active',
    name: 'Dating Banner',
    title: 'Find Your Match Today',
    description: 'Connect with singles in your area!',
    ctaText: 'Join Now',
    image: 'https://picsum.photos/800/450',
    destination: {
      type: 'smartlink',
      offerId: 'sl_1',
    },
    targeting: {
      primary: 'algorithmic',
      fallback: {
        segment: 'minnows',
        persona: 'relationship_seeker',
      },
    },
    performance: {
      impressions: 75000,
      clicks: 3750,
      conversions: 300,
      revenue: 11400,
      ctr: 0.05,
      cr: 0.08,
      rpm: 152,
      attachRate: 0.004,
      segmentPerformance: {
        whales: { ctr: 0.07, cr: 0.12, rpm: 228, attachRate: 0.0084 },
        dolphins: { ctr: 0.06, cr: 0.1, rpm: 190, attachRate: 0.006 },
        minnows: { ctr: 0.05, cr: 0.08, rpm: 152, attachRate: 0.004 },
        non_spenders: { ctr: 0.04, cr: 0.06, rpm: 114, attachRate: 0.0024 },
        churn_risk: { ctr: 0.03, cr: 0.04, rpm: 76, attachRate: 0.0012 },
      },
    },
  },
  {
    id: 'sb_3',
    status: 'active',
    name: 'VIP Membership Banner',
    title: 'Upgrade to VIP!',
    description: 'Get exclusive access to premium content!',
    ctaText: 'Upgrade Now',
    image: 'https://picsum.photos/800/450',
    destination: {
      type: 'second-click',
      offerId: 'sc_2',
    },
    targeting: {
      primary: 'algorithmic',
      fallback: {
        segment: 'dolphins',
        persona: 'status_seeker',
      },
    },
    performance: {
      impressions: 100000,
      clicks: 5000,
      conversions: 500,
      revenue: 9995,
      ctr: 0.05,
      cr: 0.1,
      rpm: 99.95,
      attachRate: 0.005,
      segmentPerformance: {
        whales: { ctr: 0.07, cr: 0.15, rpm: 149.93, attachRate: 0.0105 },
        dolphins: { ctr: 0.06, cr: 0.12, rpm: 119.94, attachRate: 0.0072 },
        minnows: { ctr: 0.05, cr: 0.1, rpm: 99.95, attachRate: 0.005 },
        non_spenders: { ctr: 0.04, cr: 0.08, rpm: 79.96, attachRate: 0.0032 },
        churn_risk: { ctr: 0.03, cr: 0.05, rpm: 49.98, attachRate: 0.0015 },
      },
    },
  },
]
// Summary data for dashboard
export const offersSummary = {
  backoffers: {
    count: 2,
    totalRevenue: 21900,
    avgRPM: 181,
    avgCR: 0.09,
    avgEPC: 3.62,
    segmentBreakdown: {
      whales: { revenue: 4380, percentage: 20 },
      dolphins: { revenue: 6570, percentage: 30 },
      minnows: { revenue: 5475, percentage: 25 },
      non_spenders: { revenue: 3285, percentage: 15 },
      churn_risk: { revenue: 2190, percentage: 10 },
    },
    geoBreakdown: {
      us: { revenue: 7665, percentage: 35 },
      ca: { revenue: 3285, percentage: 15 },
      uk: { revenue: 3285, percentage: 15 },
      au: { revenue: 2190, percentage: 10 },
      de: { revenue: 2190, percentage: 10 },
      fr: { revenue: 2190, percentage: 10 },
      other: { revenue: 1095, percentage: 5 },
    },
    deviceBreakdown: {
      desktop: { revenue: 10950, percentage: 50 },
      mobile: { revenue: 8760, percentage: 40 },
      tablet: { revenue: 2190, percentage: 10 },
    },
    algorithmCoverage: {
      algorithmic: { percentage: 65 },
      fallback: {
        lookalike: { percentage: 15 },
        broad: { percentage: 5 },
        context: { percentage: 5 },
        persona: { percentage: 10 },
      },
    },
    topPartners: [
      { id: 'partner_1', name: 'StreamMate', rpm: 210, underperforming: false },
      { id: 'partner_2', name: 'DateNow', rpm: 152, underperforming: false },
    ],
  },
  secondClickOffers: {
    count: 3,
    totalRevenue: 23865.2,
    avgRPM: 1218.31,
    avgCR: 0.0373,
    avgAttachRate: 0.0359,
    segmentBreakdown: {
      whales: { revenue: 5966.3, percentage: 25 },
      dolphins: { revenue: 7159.56, percentage: 30 },
      minnows: { revenue: 5966.3, percentage: 25 },
      non_spenders: { revenue: 2386.52, percentage: 10 },
      churn_risk: { revenue: 2386.52, percentage: 10 },
    },
    triggerBreakdown: {
      purchase_success: { revenue: 10797, percentage: 45.24 },
      ritual_complete: { revenue: 7596.2, percentage: 31.83 },
      exit_intent: { revenue: 5472, percentage: 22.93 },
    },
    placementBreakdown: {
      full_screen_modal: { revenue: 10797, percentage: 45.24 },
      bottom_sheet: { revenue: 7596.2, percentage: 31.83 },
      interstitial: { revenue: 5472, percentage: 22.93 },
    },
    algorithmCoverage: {
      algorithmic: { percentage: 70 },
      fallback: {
        lookalike: { percentage: 10 },
        broad: { percentage: 5 },
        context: { percentage: 5 },
        persona: { percentage: 10 },
      },
    },
  },
  smartlinks: {
    count: 2,
    totalRevenue: 64000,
    avgRPM: 3620,
    avgCR: 0.09,
    avgEPC: 3.62,
    segmentBreakdown: {
      whales: { revenue: 16000, percentage: 25 },
      dolphins: { revenue: 19200, percentage: 30 },
      minnows: { revenue: 16000, percentage: 25 },
      non_spenders: { revenue: 9600, percentage: 15 },
      churn_risk: { revenue: 3200, percentage: 5 },
    },
    geoBreakdown: {
      us: { revenue: 22400, percentage: 35 },
      ca: { revenue: 9600, percentage: 15 },
      uk: { revenue: 9600, percentage: 15 },
      au: { revenue: 6400, percentage: 10 },
      de: { revenue: 6400, percentage: 10 },
      fr: { revenue: 6400, percentage: 10 },
      other: { revenue: 3200, percentage: 5 },
    },
    strategyBreakdown: {
      rpm: { revenue: 30400, percentage: 47.5 },
      epc: { revenue: 33600, percentage: 52.5 },
    },
    algorithmCoverage: {
      algorithmic: { percentage: 75 },
      fallback: {
        lookalike: { percentage: 10 },
        broad: { percentage: 5 },
        context: { percentage: 5 },
        persona: { percentage: 5 },
      },
    },
  },
  total: {
    totalRevenue: 109765.2,
    revenueByType: {
      backoffers: { revenue: 21900, percentage: 19.95 },
      secondClickOffers: { revenue: 23865.2, percentage: 21.74 },
      smartlinks: { revenue: 64000, percentage: 58.31 },
    },
    segmentBreakdown: {
      whales: { revenue: 26346.6, percentage: 24 },
      dolphins: { revenue: 32929.56, percentage: 30 },
      minnows: { revenue: 27441.3, percentage: 25 },
      non_spenders: { revenue: 15271.52, percentage: 13.91 },
      churn_risk: { revenue: 7776.52, percentage: 7.09 },
    },
    algorithmCoverage: {
      algorithmic: { percentage: 70 },
      fallback: {
        lookalike: { percentage: 11.67 },
        broad: { percentage: 5 },
        context: { percentage: 5 },
        persona: { percentage: 8.33 },
      },
    },
  },
}
